import { NATALKA_SIZE } from './NatalkaSprite.js';
import { ySortDepth } from './ySort.js';

// Painter's-algorithm y-sort for a scene's walkable layer: the local avatar (or the bike
// rider while riding), placed objects and remote avatars all get depth = their ground
// anchor's y, so whoever/whatever is lower on screen is drawn in front. Call every frame
// from update(); it's cheap (a handful of setDepth calls).
//
//   depthSortScene(scene, {
//     actor:      sprite whose feet are at sprite.y + NATALKA_SIZE.h / 2 (Natalka or a rider),
//     placements: iterable of placement sprites (anchor = bottom edge),
//     presence:   the attachRemotePresence handle (avatars + their bike images),
//     halfH:      distance from a person's sprite centre to their feet — the default is
//                 half the 240 px indoor art; the outdoor scenes draw her at 120, and there
//                 the number has to be right because cars are sorted against it,
//     actorHalfH: …and the actor is not always a person: on the street it can be the car
//                 she is driving, whose ground line is its wheels (defaults to halfH).
//   })
const HALF_H = NATALKA_SIZE.h / 2;

export function depthSortScene(scene, { actor, placements, presence, halfH = HALF_H,
  actorHalfH = halfH } = {}) {
  if (actor) actor.setDepth(ySortDepth(actor.feetY ?? (actor.y + actorHalfH)));
  if (placements) {
    for (const sp of placements) sp.setDepth(ySortDepth(sp.y + sp.displayHeight / 2));
  }
  if (presence) {
    for (const a of presence.avatars.values()) {
      // Outdoors an avatar knows its own ground line (its feet, or the wheels of the bike or
      // car it is on, worked back out of its y through the perspective) — a peer driving in
      // the near lane has to sort in front of one cycling up the pavement. Indoors there is
      // no such getter and everyone is a person, so the flat half-height stands.
      const d = ySortDepth(a.groundY ?? a.sprite.feetY ?? (a.sprite.y + halfH));
      a.sprite.setDepth(d);
      a.bike?.setDepth(d);          // a riding peer's bike image sits with its rider
      a.car?.setDepth(d);           // …and a driving peer's car with its driver
    }
  }
}
